import { type ReactElement } from 'react';
import { TableV2NestedFrame } from '@/features/shared/components/tableSystem/TableV2NestedFrame';
import {
  buildTableV2NestedBodyRowSx,
  tableV2NestedDepthSx,
  type TableV2NestedTableDepth,
} from '@/features/shared/components/tableSystem/TableV2NestedTable';
import { tableV2NestedBodyRowHeightPx } from '@/features/shared/components/tableSystem/TableV2Primitives';
import { s } from '@/theme/tokens';
import { Box, Table, TableBody, TableCell, TableHead, TableRow } from '@/ui/primitives';
import { tableV2NestedEmptyTextSx } from './TableV2NestedEmptyState.styles';

export const TableV2NestedEmptyState = ({
  ariaLabel,
  colgroup,
  colSpan,
  depth,
  header,
  text = 'No data',
}: {
  ariaLabel: string;
  colgroup: ReactElement;
  colSpan: number;
  depth: TableV2NestedTableDepth;
  header: ReactElement;
  text?: string;
}): ReactElement => (
  <TableV2NestedFrame depth={depth}>
    <Table aria-label={ariaLabel} sx={tableV2NestedDepthSx[depth].table}>
      {colgroup}
      <TableHead>{header}</TableHead>
      <TableBody>
        <TableRow sx={buildTableV2NestedBodyRowSx({ depth, hasRenderedDivider: false })}>
          <TableCell
            align="center"
            colSpan={colSpan}
            sx={{
              height: `${String(tableV2NestedBodyRowHeightPx)}px`,
              py: `${s('sm')} !important`,
            }}
          >
            <Box
              component="span"
              sx={[
                {
                  color: (theme) => theme.app.colors.textMuted,
                },
                tableV2NestedEmptyTextSx,
              ]}
            >
              {text}
            </Box>
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  </TableV2NestedFrame>
);
